import { Stack } from 'expo-router';

export default function TournamentLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
